import { render, staticRenderFns } from "./AddToCartSidebar.vue?vue&type=template&id=75fc8b52"
import script from "./AddToCartSidebar.vue?vue&type=script&lang=ts"
export * from "./AddToCartSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports